import { updateGlobalLookForLastTimeStampBeforeFetchingData } from "@src/reducers/your-reducer";
import { useDispatch } from "react-redux";

export interface EnableDisableAllBlueprintDashboardTogglesObj {
  onEnableAllToggles: () => void;
  onDisableAllToggles: () => void;
}

export const useEnableDisableAllBlueprintDashboardTogglesHook =
  (): EnableDisableAllBlueprintDashboardTogglesObj => {
    const dispatch = useDispatch();

    const setEnableAllToggles = (value: boolean) => {
      dispatch(updateGlobalLookForLastTimeStampBeforeFetchingData(value));
    };

    const onEnableAllToggles = () => {
      setEnableAllToggles(true);
    };

    const onDisableAllToggles = () => {
      setEnableAllToggles(false);
    };

    return {
      onEnableAllToggles: onEnableAllToggles,
      onDisableAllToggles: onDisableAllToggles,
    };
  };
